import { render, staticRenderFns } from "./serviceOverview.vue?vue&type=template&id=7d35b358&scoped=true"
import script from "./serviceOverview.vue?vue&type=script&lang=js"
export * from "./serviceOverview.vue?vue&type=script&lang=js"
import style0 from "./serviceOverview.vue?vue&type=style&index=0&id=7d35b358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35b358",
  null
  
)

export default component.exports